import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=d59912c8&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=d59912c8&prod&lang=scss&scoped=true"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=d59912c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59912c8",
  null
  
)

export default component.exports